import React from "react";
import { normalizeNumbers } from "@SeemplicityDev/shared";
import useAddRef, { UseAddRefOptions } from "../useAddRef";

interface CvesPageProps extends UseAddRefOptions {
  data?: {
    all_cves_count: number;
    exploitable_cves_count: number;
    is_rce_count: number;
    exploited_in_the_wild_count: number;
    reachable_cves_count: number;
    internet_exposed_cves_count: number;
  };
  hasAggregations?: boolean;
}

const keyToTitleMap: Record<string, string> = {
  all_cves_count: "All Vulnerabilities",
  exploitable_cves_count: "Exploitable",
  is_rce_count: "Remote Code Execution",
  exploited_in_the_wild_count: "Exploited in the Wild",
  reachable_cves_count: "Reachable",
  internet_exposed_cves_count: "Internet Exposed",
};

const CvesPage: React.FC<CvesPageProps> = ({
  index,
  data,
  addRef,
  hasAggregations = false,
}) => {
  const ref = useAddRef({ addRef });

  return (
    <div className={`eoy-page cves-page`} ref={ref}>
      {!hasAggregations && <h3>Findings</h3>}
      <h4>
        <span className="main">From Noise to Action:</span>{" "}
        <span className="sub">CVEs That Matter Most</span>
      </h4>
      <div
        className="cves-container"
        style={
          {
            "--all-items-length": Object.keys(data || {}).length,
          } as React.CSSProperties
        }
      >
        {!!data &&
          Object.entries(data).map(([key, value], index) => {
            return (
              <div className="item-wrapper" key={key}>
                <div className={`cve-item`}>
                  <span className="cve-item-value">
                    {normalizeNumbers(value, 2)}
                  </span>
                  <span className="cve-item-title">{keyToTitleMap[key]}</span>
                </div>
                {index !== Object.keys(data).length - 1 && (
                  <i className="seem-icon-next-arrow right-arrow" />
                )}
              </div>
            );
          })}
      </div>
    </div>
  );
};

export default CvesPage;
